import { Controller } from '@hotwired/stimulus';

export default class ValidateDecisionFormController extends Controller {
  static targets = ['decisionOption', 'decisionSubmitButton'];

  checkEmpty () {
    this.decisionSubmitButtonTarget.disabled = !this.anyStatusSelected();
  }

  anyStatusSelected () {
    return this.decisionOptionTargets.some(target => target.checked);
  }
}
